<div class="container">
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form [formGroup]="addClientForm" (ngSubmit)="addClientSubmit()">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label>{{'clients.addClients.businessName' | translate}} *</label>
                    <input type="text" name="businessName" id="businessName" formControlName="businessName" required
                      placeholder="{{'clients.addClients.businessName' | translate}}"
                      class="form-control {{errorArray['businessName'] ? 'is-invalid' : ''}}" />
                    <div class="invalid-feedback">
                      {{errorArray['de']}}
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{'clients.addClients.phone' | translate}} </label>
                    <input type="text" name="phone" id="phone" formControlName="phone" placeholder="{{'clients.addClients.phone' | translate}}"
                      class="form-control {{errorArray['phone'] ? 'is-invalid' : ''}}" />
                    <div class="invalid-feedback">
                      {{errorArray['de']}}
                    </div>
                  </div>
                  <div class="form-group">
                    <label>{{'clients.addClients.address' | translate}}</label>
                    <input type="text" name="address" id="address" formControlName="address"
                      placeholder="{{'clients.addClients.address' | translate}}" class="form-control {{errorArray['address'] ? 'is-invalid' : ''}}" />
                    <div class="invalid-feedback">
                      {{errorArray['de']}}
                    </div>
                  </div>
                </div>
                <div class="col">
                  <fieldset formGroupName="account">
                    <div class="form-group">
                      <label>{{'clients.addClients.userName' | translate}}*</label>
                      <input type="text" name="username" id="username" formControlName="username" required
                        placeholder="{{'clients.addClients.userName' | translate}}" class="form-control {{errorArray['username'] ? 'is-invalid' : ''}}" />
                      <div class="invalid-feedback">
                        {{errorArray['de']}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{'clients.addClients.firstName' | translate}}*</label>
                      <input type="text" name="firstName" id="firstName" formControlName="firstName" required
                        placeholder="{{'clients.addClients.firstName' | translate}}" class="form-control {{errorArray['firstName'] ? 'is-invalid' : ''}}" />
                      <div class="invalid-feedback">
                        {{errorArray['de']}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{'clients.addClients.lastName' | translate}}*</label>
                      <input type="text" name="lastName" id="lastName" formControlName="lastName" required
                        placeholder="{{'clients.addClients.lastName' | translate}}" class="form-control {{errorArray['lastName'] ? 'is-invalid' : ''}}" />
                      <div class="invalid-feedback">
                        {{errorArray['de']}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{'clients.addClients.email' | translate}}*</label>
                      <input type="email" name="email" id="email" formControlName="email" required
                        placeholder="{{'clients.addClients.email' | translate}}" class="form-control {{errorArray['email'] ? 'is-invalid' : ''}}" />
                      <div class="invalid-feedback">
                        {{errorArray['de']}}
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{'clients.addClients.password' | translate}} *</label>
                      <input type="password" name="newPassword" id="newPassword" formControlName="newPassword"
                        placeholder="{{'clients.addClients.password' | translate}}" class="form-control {{errorArray['newPassword'] ? 'is-invalid' : ''}}" />
                      <div class="invalid-feedback">
                        {{errorArray['de']}}
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
              <div class="row">
                <div class="col text-right">
                  <button type="submit" class="btn btn-primary">{{'clients.addClients.update' | translate}}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>